"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var appMargins_1 = __importDefault(require("../../../../../app/components/AppMargins/appMargins"));
var PaginationActionComponent_1 = __importDefault(require("../../../../../app/components/widgets/PaginationActionComponent"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c, _d;
    return core_1.createStyles({
        pagination: (_a = {
                zIndex: -1,
                marginTop: theme.spacing(2),
                marginBottom: theme.spacing(6)
            },
            _a[theme.breakpoints.up('md')] = {
                marginTop: theme.spacing(6.5),
            },
            _a),
        paginationCell: {
            padding: 0,
            border: 'none',
            width: '100%',
        },
        paginationRow: {
            height: 'fit-content',
            border: 'none',
        },
        toolbar: {
            paddingLeft: function (props) {
                return props.appMargins;
            },
            paddingRight: function (props) {
                return props.appMargins;
            },
        },
        spacer: {
            flex: 0,
        },
        caption: (_b = {
                fontWeight: 400,
                marginRight: '4px'
            },
            _b[theme.breakpoints.down('sm')] = {
                display: 'none',
            },
            _b),
        select: (_c = {
                border: 'solid 1px #d8d8d8',
                zIndex: 2
            },
            _c[theme.breakpoints.down('sm')] = {
                display: 'none',
            },
            _c),
        selectIcon: (_d = {
                zIndex: 2
            },
            _d[theme.breakpoints.down('sm')] = {
                display: 'none',
            },
            _d),
    });
});
/**
 * @component Holds the drop down option for the result count and page number.
 */
var DirectoryTablePagination = function (_a) {
    var pageCount = _a.pageCount, rowsPerPage = _a.rowsPerPage, resultsCount = _a.resultsCount, currentPage = _a.currentPage, disablePagination = _a.disablePagination, changePageHandler = _a.changePageHandler, changeRowsPerPageHandler = _a.changeRowsPerPageHandler;
    var appMargins = appMargins_1.default();
    var classes = useStyles({ appMargins: appMargins });
    return (react_1.default.createElement(core_1.TableRow, { key: "pagination", className: classes.paginationRow },
        react_1.default.createElement(core_1.TableCell, { className: classes.paginationCell },
            react_1.default.createElement(core_1.TablePagination, { className: classes.pagination, ActionsComponent: function (_a) {
                    var onPageChange = _a.onPageChange, page = _a.page;
                    return (react_1.default.createElement(PaginationActionComponent_1.default, { pageCount: pageCount, onChangePage: onPageChange, page: page, disablePagination: disablePagination }));
                }, labelRowsPerPage: "Links per page", rowsPerPageOptions: [10, 25, 100], component: "div", count: resultsCount, rowsPerPage: rowsPerPage, page: currentPage, backIconButtonProps: {
                    'aria-label': 'previous page',
                }, nextIconButtonProps: {
                    'aria-label': 'next page',
                }, onPageChange: changePageHandler, onChangeRowsPerPage: changeRowsPerPageHandler, classes: {
                    spacer: classes.spacer,
                    toolbar: classes.toolbar,
                    caption: classes.caption,
                    select: classes.select,
                    selectIcon: classes.selectIcon,
                } }))));
};
exports.default = DirectoryTablePagination;
